export const DefaultToastStyle =
  'min-w-[335px] w-auto! min-h-[52px]! bg-black/80! font-medium! text-white! typo-label1 p-4! whitespace-break-spaces!'

export const CenteredToastStyle =
  'flex justify-center fixed! top-1/2 right-1/2 translate-x-1/2 -translate-y-1/2 text-center whitespace-break-spaces'
